/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Why a billing period is not fully projected onto an entitlement.
 */
export type EntitlementProjectionFailure = typeof EntitlementProjectionFailure[keyof typeof EntitlementProjectionFailure];


export const EntitlementProjectionFailure = {
  overlap_conflict: 'overlap_conflict',
  expired_before_sync: 'expired_before_sync',
  linked_overlap: 'linked_overlap',
} as const;
